import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewLogin from "../views/ViewLogin";

const ContainerComponente = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto; /* header - conteúdo - footer */
  min-height: 100dvh; /* ocupa a altura exata da viewport dinâmica */
  background: linear-gradient(135deg, #003644, #0096c7);

  @media (max-width: 768px) {
    min-height: 100dvh; /* cobre toda a tela no mobile também */
  }
`;


const Login: React.FC = () => (
  <>
    <ContatoZap />
    <ContainerComponente>
      <ViewAppBar />
      <ViewLogin />
      <ViewFooter />
    </ContainerComponente>
  </>
);
export default Login;
